import { render, staticRenderFns } from "./craftsman.vue?vue&type=template&id=1d2ca98a&scoped=true&"
import script from "./craftsman.vue?vue&type=script&lang=js&"
export * from "./craftsman.vue?vue&type=script&lang=js&"
import style0 from "./craftsman.vue?vue&type=style&index=0&id=1d2ca98a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ca98a",
  null
  
)

export default component.exports